import { applyDateRangePreset, dateRangePreset, endDate, setDateRangeState, startDate } from './state';
import type { DateRangePreset } from './state';

const toDateOnlyIso = (date: Date) => date.toISOString().split('T')[0] ?? '';
const toDateInputValue = (value: string) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return toDateOnlyIso(date);
};

const DateSelect = () => {
    const customRange = dateRangePreset.value === 'custom';
    const rangeType =
        dateRangePreset.value === 'today'
            ? 'day'
            : dateRangePreset.value === 'current_month'
                ? 'month'
                : null;

    const handleDateChange = (e: any) => {
        const preset = e.currentTarget.value as DateRangePreset;

        if (preset === 'custom') {
            setDateRangeState(
                'custom',
                toDateInputValue(startDate.value),
                toDateInputValue(endDate.value)
            );
            return;
        }

        applyDateRangePreset(preset);
    };

    return (
        <div className="control-group">
            {rangeType === 'day' && (
                <div>
                    <button onClick={() => {
                        const currentStart = new Date(startDate.value);
                        const currentEnd = new Date(endDate.value);
                        const priorDayStart = new Date(currentStart);
                        const priorDayEnd = new Date(currentEnd);
                        priorDayStart.setDate(currentStart.getDate() - 1);
                        priorDayEnd.setDate(currentEnd.getDate() - 1);
                        setDateRangeState(dateRangePreset.value, toDateOnlyIso(priorDayStart), toDateOnlyIso(priorDayEnd));
                    }}>
                        <span style={{ display: 'inline-block', transform: 'translateY(2px)' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 4l-4 4 4 4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                    </button>
                    <button 
                        onClick={() => {
                            const currentStart = new Date(startDate.value);
                            const currentEnd = new Date(endDate.value);
                            const nextDayStart = new Date(currentStart);
                            const nextDayEnd = new Date(currentEnd);
                            nextDayStart.setDate(currentStart.getDate() + 1);
                            nextDayEnd.setDate(currentEnd.getDate() + 1);
                            setDateRangeState(dateRangePreset.value, toDateOnlyIso(nextDayStart), toDateOnlyIso(nextDayEnd));
                        }} 
                        style={{ marginLeft: '4px' }}
                    >
                        <span style={{ display: 'inline-block', transform: 'translateY(2px)' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                    </button>
                </div>
            )}
            {rangeType === 'month' && (
                <div>
                    <button onClick={() => {
                        const currentStart = new Date(startDate.value);
                        const currentEnd = new Date(endDate.value);
                        const priorMonthStart = new Date(currentStart.getFullYear(), currentStart.getMonth() - 1, 1);
                        const priorMonthEnd = new Date(currentEnd.getFullYear(), currentEnd.getMonth(), 0);
                        setDateRangeState(dateRangePreset.value, priorMonthStart.toISOString(), priorMonthEnd.toISOString());
                    }}>
                        <span style={{ display: 'inline-block', transform: 'translateY(2px)' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 4l-4 4 4 4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                    </button>
                    <button 
                        onClick={() => {
                            const currentStart = new Date(startDate.value);
                            const currentEnd = new Date(endDate.value);
                            const nextMonthStart = new Date(currentStart.getFullYear(), currentStart.getMonth() + 1, 1);
                            const nextMonthEnd = new Date(currentEnd.getFullYear(), currentEnd.getMonth() + 2, 0);
                            setDateRangeState(dateRangePreset.value, nextMonthStart.toISOString(), nextMonthEnd.toISOString());
                        }} 
                        style={{ marginLeft: '4px' }}
                    >
                        <span style={{ display: 'inline-block', transform: 'translateY(2px)' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                    </button>
                </div>
            )}
            <select value={dateRangePreset.value} onChange={handleDateChange}>
                <option value="live">Live</option>
                <option value="today">Oggi</option>
                <option value="last_7_days">Ultimi 7 giorni</option>
                <option value="last_30_days">Ultimi 30 giorni</option>
                <option value="current_month">Mese corrente</option>
                <option value="all_time">Tutto il periodo</option>
                <option value="custom">Intervallo personalizzato</option>
            </select>
            {customRange && (
                <div className="flex gap-1">
                    <input 
                        type="date" 
                        value={toDateInputValue(startDate.value)} 
                        onInput={(e) => {
                            setDateRangeState('custom', e.currentTarget.value, toDateInputValue(endDate.value));
                        }} 
                    />
                    <input 
                        type="date" 
                        value={toDateInputValue(endDate.value)} 
                        onInput={(e) => {
                            setDateRangeState('custom', toDateInputValue(startDate.value), e.currentTarget.value);
                        }} 
                    />
                </div>
            )}
        </div>
    );
};

export default DateSelect;
